import { DestroyRef, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ResiliationService } from '../services/resiliation.service';
import { LabelStepAction, StatutStepAction, TypeStepAction } from '../models/constantes-utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IdentificationService } from '../services/identification.service';

@Injectable({
    providedIn: 'root'
})
export class AnnulationGuard {

    constructor(private router: Router,
                private idService: IdentificationService,
                private resiliationService: ResiliationService,
                private destroyRef: DestroyRef) {
    }

    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        const number = this.idService.selectedLineNumber();
        if (!number) {
            this.router.navigate(['accueil']);
            return false;
        }

        this.resiliationService.getSuiviResiliation(number)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(reponseSuiviResiliation => {
                const steps = reponseSuiviResiliation.reponse?.suiviResiliation.stepList;
                const currentStep = steps?.find(step => step.status === StatutStepAction.CURRENT);

                const actionAnnulation = currentStep?.actionList.find(action => action.type === TypeStepAction.BUTTON && action.label === LabelStepAction.ANNULER);
                if (!actionAnnulation) {
                    this.router.navigate(['accueil']);
                }
            });
        return true;
    }
}
